import { JourneyIconButton } from 'ui/journey-builder/node-types/common';
import { NodeContainer } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

type ActionType = 'journey_loop';

export const Node = (node: JourneyNode<ActionType>) => (
  <NodeContainer node={node}>
    <JourneyIconButton node={node} color="teal100" isSelectable />
  </NodeContainer>
);
